const REGEXP_URL =
  /^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

const REGEXP_DOMAIN = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)(\.(?!-)[A-Za-z0-9-]{1,63}(?<!-))+$/;
const REGEXP_EMAIL = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const REGEXP_NUMBERS = /^\d+$/;
const REGEX_RULENAME = /^[A-Za-z0-9_-]+$/;

export const isNumerical = (value) => {
  return REGEXP_NUMBERS.test(value);
};

export const isValidDomain = (value) => {
  return REGEXP_DOMAIN.test(value);
};

export const isValidEmail = (value) => {
  return REGEXP_EMAIL.test(value);
};

export const isValidUrl = (value) => {
  return REGEXP_URL.test(value);
};

export const isValidRuleName = (value) => {
  return REGEX_RULENAME.test(value);
};
